import React from "react";
import type { DemoAsk } from "../lib/demoRequest";
import "./SwipeHint.css";
import { t } from "../i18n";

interface Props {
  /** A pending DEMO card's gesture (and no real request is waiting): the line names it. */
  demoAsk: DemoAsk | null;
}

// The one quiet line under "Pending Requests" while there's something to
// swipe (nothing waiting = no line). Real requests keep "Swipe
// for actions."; a pending practice card gets the exact direction in its own
// colour, the arrow bobbing toward the side (founder, 1.5.1 #6). Phones only —
// desktop has buttons, so OfferCard.css hides .swipe-hint under pointer: fine.
export default function SwipeHint({ demoAsk }: Props) {
  if (demoAsk === "accept") {
    return (
      <div className="swipe-hint swipe-hint--accept">
        {t("requestsPage.swipeRightToAccept")} <span className="swipe-hint-arrow" aria-hidden="true">→</span>
      </div>
    );
  }
  if (demoAsk === "decline") {
    return (
      <div className="swipe-hint swipe-hint--decline">
        <span className="swipe-hint-arrow" aria-hidden="true">←</span> {t("requestsPage.swipeLeftToDecline")}
      </div>
    );
  }
  return <div className="swipe-hint">{t("requestsPage.swipeForActions")}</div>;
}

// The line under "Queued" once nothing is left to swipe (founder, 1.5.1 #6:
// "does it nudge them to click the green ($10) button? people might just
// leave it there"): the practice card's own Play label, on the right, right
// above that button — "Played it?" over "Tap $5 ↓" (founder, build 44), the
// arrow bobbing down at it; the button pulses too (OfferCard.css). Desktop
// shows it as well — tapping Play is the same everywhere.
export function PlayHint({ amount }: { amount: string }) {
  return (
    <div className="play-hint">
      <span className="play-hint-q">{t("requestsPage.playedIt")}</span>
      <span className="play-hint-tap">
        {t("requestsPage.tapAmount", { amount })} <span className="swipe-hint-arrow play-hint-arrow" aria-hidden="true">↓</span>
      </span>
    </div>
  );
}
